import { FC, useContext } from 'react';
import { context as StateContext } from '../context/state';
import { context as DependencyContext } from '../context/dependency';
import Page from '../page/JavaScriptCodePage';

type Props = { className?: string };

const JavascriptCodePage: FC<Props> = ({ className }) => {
  const state = useContext(StateContext);
  const dependency = useContext(DependencyContext);

  return (
    <Page
      organization={state.lastAccessedOrganization.item}
      notifyUnimportant={dependency.messageDispatcher.notifyUnimportant}
      siteScript={state.siteScript.data}
      siteScriptLoading={state.siteScript.fetching > 0}
      rootDomains={state.rootDomains.data}
      rootDomainsLoading={state.rootDomains.fetching > 0}
      siteJsPermission={state.siteJsPermission.data}
      siteJsPermissionLoading={state.siteJsPermission.fetching > 0}
      postRootDomain={dependency.javaScirptCodeUsecase.postRootDomains}
      putRootDomain={dependency.javaScirptCodeUsecase.putRootDomains}
      deleteRootDomain={dependency.javaScirptCodeUsecase.deleteRootDomains}
      putSiteScript={dependency.javaScirptCodeUsecase.putSiteScript}
      onMount={() => {
        dependency.javaScirptCodeUsecase.getSiteJsPermission();
        dependency.javaScirptCodeUsecase.getSiteScript();
        dependency.javaScirptCodeUsecase.getRootDomains();
      }}
      className={className}
    />
  );
};

export default JavascriptCodePage;
